import {
  PostCardFragmentFragment,
  RepostCardFragmentFragment,
  StreamPostCardFragmentFragment,
  TournamentPostCardFragmentFragment,
} from '@/__generated__/graphql.ts';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import { useAuthInfo } from '@/routes/_app/use-auth-info.ts';
import { PostCardRepostAuthor } from './post-card-repost-author.tsx';
import {
  postCardRepostedLink,
  postCardTopHeaderContainer,
} from './post-card.css.ts';

export const PostCardTopHeader = ({
  post,
}: {
  post:
    | PostCardFragmentFragment
    | RepostCardFragmentFragment
    | TournamentPostCardFragmentFragment
    | StreamPostCardFragmentFragment;
}) => {
  const me = useAuthInfo();

  const isRepost = post.__typename === 'RePost';
  const isMyRepost = isRepost && post.author?.id === me.id;

  return (
    <div className={postCardTopHeaderContainer}>
      {isRepost &&
        (isMyRepost ? (
          <PostCardRepostAuthor fullName={'You'} />
        ) : (
          <Link
            to={paths.makeUser(post.author.username)}
            onClick={(e) => e.stopPropagation()}
            className={postCardRepostedLink}
          >
            <PostCardRepostAuthor fullName={post.author.fullName} />
          </Link>
        ))}
    </div>
  );
};
